<template>
  <div id="weeklyReportCus" element-loading-background="rgba(255, 255, 255, 0.4)">
    <div style="padding-bottom: 10px">
      <el-button type="primary" size="small" @click="openHistoryDialog">Historical Weekly Report</el-button>
      <el-button type="primary" size="small" v-if="allData && allData.projectStatus !== 6 && allData.projectStatus !== 5" @click="openRecipientDialog()" >Send Weekly Report</el-button>
    </div>
    <h2>{{ allData && allData.projectName }} Project Weekly Report</h2>
    <el-form :model="weeklyReportCusForm" ref="weeklyReportCusForm" labelWidth="0px">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Basic Information of Project" name="1">
          <el-row>
            <el-col :span="0">
              <el-form-item prop="majorProjectId">
                <el-input  v-model="weeklyReportCusForm.majorProjectId" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Manager:" prop="projectManager" :rules="[{ required: true, message: 'Please input'}]" labelWidth="141px">
                <el-input v-model="weeklyReportCusForm.projectManager" clearable placeholder="Please input"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :xs="24" :md="12">
              <el-form-item label="Technical Manager:" prop="technicalManager" :rules="[{ required: true, message: 'Please input'}]" labelWidth="160px">
                <el-input v-model="weeklyReportCusForm.technicalManager" clearable placeholder="Please input"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Project Overview:" prop="projectOverview" :rules="[{ required: true, message: 'Please input'}]" labelWidth="141px">
                <el-input type="textarea" clearable :rows="5" v-model="weeklyReportCusForm.projectOverview" maxlength="1000" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Overall Project Progress" name="2">
          <el-row>
            <el-col :span="24">
              <el-form-item label="" prop="overallProjectProgress" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" clearable :rows="5" v-model="weeklyReportCusForm.overallProjectProgress" maxlength="1000" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Escalate and Help" name="3">
          <template slot="title">
            Escalate and Help
            <i
              class="el-icon-circle-plus-outline"
              style="font-size: 18px;color: #409EFF;margin: 0 5px;"
              @click.stop="addRow(-1, 'helpList')" v-if="weeklyReportCusForm.helpList.length === 0"
            >
            </i>
          </template>
          <el-table :data="weeklyReportCusForm.helpList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'helpList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'helpList')"></i>
              </template>
            </el-table-column>
            <el-table-column prop="escalateDescription" align="center" label="Escalate description">
              <template slot-scope="scope">
                <el-form-item  :prop="'helpList.' + scope.$index + '.escalateDescription'" label-width="0">
                  <el-input type="textarea" v-model="scope.row.escalateDescription" maxlength="500" clearable :title="scope.row.escalateDescription" placeholder="Please input" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="theDepartmentThatIsSeekingHelp" align="center" label="The department that is seeking help">
              <template slot-scope="scope">
                <el-form-item  :prop="'helpList.' + scope.$index + '.theDepartmentThatIsSeekingHelp'"  label-width="0">
                  <el-input type="textarea" v-model="scope.row.theDepartmentThatIsSeekingHelp" maxlength="200" clearable :title="scope.row.theDepartmentThatIsSeekingHelp" placeholder="Please input" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="theTimeOfResolution" align="center" width="200" label="The time of resolution">
              <template slot-scope="scope">
                <el-form-item  :prop="'helpList.' + scope.$index + '.theTimeOfResolution'" label-width="0">
                  <el-date-picker
                    v-model="scope.row.theTimeOfResolution"
                    type="date"
                    value-format="yyyy-MM-dd" 
                    placeholder=""
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Risk Management" name="4">
          <template slot="title">
            Risk Management
            <i
              class="el-icon-circle-plus-outline"
              style="font-size: 18px;color: #409EFF;margin: 0 5px;"
              @click.stop="addRow(-1, 'riskList')" v-if="weeklyReportCusForm.riskList.length === 0"
            >
            </i>
          </template>
          <el-table :data="weeklyReportCusForm.riskList" border  class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'riskList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'riskList')"></i>
              </template>
            </el-table-column>
            <el-table-column prop="riskLevel" width="200" label="Risk Level">
              <template v-slot="scope">
                <el-form-item :prop="'riskList.' + scope.$index + '.riskLevel'">
                  <el-select clearable v-model="scope.row.riskLevel" placeholder="">
                    <el-option
                      v-for="item in riskLevel"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="riskDescription" min-width="350" label="Risk Description">
              <template v-slot="scope">
                <el-form-item :prop="'riskList.' + scope.$index + '.riskDescription'">
                  <el-input type="textarea" v-model="scope.row.riskDescription" maxlength="500" clearable :title="scope.row.riskDescription"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="responseMeasures" min-width="350" label="Response Measures">
              <template v-slot="scope">
                <el-form-item :prop="'riskList.' + scope.$index + '.responseMeasures'">
                  <el-input type="textarea" v-model="scope.row.responseMeasures" clearable maxlength="500" :title="scope.row.responseMeasures"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="owner" width="180" label="Owner">
              <template v-slot="scope">
                <el-form-item :prop="'riskList.' + scope.$index + '.owner'">
                  <el-input v-model="scope.row.owner" clearable :title="scope.row.owner"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="plannedClosingDate" width="180" label="Planned Closing Date">
              <template v-slot="scope">
                <el-form-item :prop="'riskList.' + scope.$index + '.plannedClosingDate'">
                  <el-date-picker
                    v-model="scope.row.plannedClosingDate"
                    type="date"
                    value-format="yyyy-MM-dd" 
                    placeholder=""
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Weekly Progress" name="5">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Weekly Report Period:" labelWidth="170px" prop="weeklyStartEndDate" :rules="[{ required: true, message: 'Please input'}]">
                <el-date-picker
                  v-model="weeklyReportCusForm.weeklyStartEndDate"
                  type="daterange"
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="weeklyReportCusForm.thisWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'thisWeekWorkProgressList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'thisWeekWorkProgressList')" v-if="scope.$index !== 0"></i>
              </template>
            </el-table-column>
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" align="center">
              <template slot="header">
                <span class="hasStar">Tasks Completed<span>*</span></span>
              </template>
              <template slot-scope="scope">
                <el-form-item  :prop="'thisWeekWorkProgressList.' + scope.$index + '.jobContent'"  :rules="{ required: true, message: 'Please input' }" label-width="0">
                  <el-input type="textarea" v-model="scope.row.jobContent" maxlength="1000" clearable :title="scope.row.jobContent" placeholder="Please input" />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
          <h3></h3>
          <el-table :data="weeklyReportCusForm.nextWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'nextWeekWorkProgressList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'nextWeekWorkProgressList')" v-if="scope.$index !== 0"></i>
              </template>
            </el-table-column>
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" align="center">
              <template slot="header">
                <span class="hasStar">Next Week Plan<span>*</span></span>
              </template>
              <template slot-scope="scope">
                <el-form-item  :prop="'nextWeekWorkProgressList.' + scope.$index + '.jobContent'"  :rules="{ required: true, message: 'Please input' }" label-width="0">
                  <el-input type="textarea" v-model="scope.row.jobContent" maxlength="1000" clearable :title="scope.row.jobContent" placeholder="Please input" />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Project Milestone" name="6">
          <template slot="title">
            Project Milestone
            <i
              class="el-icon-circle-plus-outline"
              style="font-size: 18px;color: #409EFF;margin: 0 5px;"
              @click.stop="addRow(-1, 'milestoneList')" v-if="weeklyReportCusForm.milestoneList.length === 0"
            >
            </i>
          </template>
          <el-table :data="weeklyReportCusForm.milestoneList" border class="milestone-table" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50" fixed="left">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'milestoneList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'milestoneList')"></i>
              </template>
            </el-table-column>
            <el-table-column prop="keyTask" min-width="180" label="Key Task">
              <template v-slot="scope">
                <el-form-item :prop="'milestoneList.' + scope.$index + '.keyTask'">
                  <el-input v-model="scope.row.keyTask" :title="scope.row.keyTask" clearable></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="keyTaskDesc:" min-width="220" label="Key Task Description">
              <template v-slot="scope">
                <el-form-item :prop="'milestoneList.' + scope.$index + '.keyTaskDesc'">
                  <el-input type="textarea" v-model="scope.row.keyTaskDesc" :title="scope.row.keyTaskDesc" maxlength="500" clearable></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="progressPercentage" label="Progress Percentage (%)" min-width="180">
              <template v-slot="scope">
                <el-form-item :prop="'milestoneList.' + scope.$index + '.progressPercentage'">
                <el-input-number clearable :min="0" :max="100" :controls="false" v-model="scope.row.progressPercentage" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="currentStatus" min-width="180" label="Current Status">
              <template v-slot="scope">
                <el-form-item :prop="'milestoneList.' + scope.$index + '.currentStatus'">
                  <el-select clearable v-model="scope.row.currentStatus" placeholder="">
                    <el-option
                      v-for="item in milestoneStatus"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="startDate" label="Start Date" min-width="150">
              <template v-slot="scope">
                <el-form-item :prop="'milestoneList.' + scope.$index + '.startDate'">
                  <el-date-picker
                    v-model="scope.row.startDate"
                    type="date"
                    value-format="yyyy-MM-dd" 
                    placeholder=""
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" min-width="150" label="End Date">
              <template v-slot="scope">
                <el-form-item :prop="'milestoneList.' + scope.$index + '.endDate'">
                  <el-date-picker
                    v-model="scope.row.endDate"
                    type="date"
                    value-format="yyyy-MM-dd" 
                    placeholder=""
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div style="text-align: center; padding-top: 10px">
        <el-button type="primary" size="small" :loading="confirmLoading" v-if="allData && allData.projectStatus !== 5" @click="confirmWeekly('confirmLoading')">Save</el-button>
      </div>
    </el-form>
    <history-dialog ref="historyDialog" :id="id" />
    <el-dialog
			title="Email Address for Sending Project Weekly Report"
			width="855px"
			top="5vh"
			:visible.sync="recipientModal"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			@closed="closeRecipientDialog"
		>
      <el-form :model="recipientForm" ref="recipientForm" label-width="120px" class="recipientForm">
        <p style="font-weight: 700; font-size: 13px;padding: 0 8px 14px 20px;margin-top: -20px;color: red;line-height: 21px;word-break:break-word;">
          <i class="el-icon-warning-outline" style="font-size: 16px" />
          The recipients and CC recipients of the weekly report are imported from the project appointment. If you want to add or modify recipients and CC recipients, please enter the recipients and cc recipients directly, separated by semicolon (;)  (English input method).	
        </p>
        <el-form-item prop="address" label="Recipient:" :rules="[{ required: true, message: 'Please input'}]">
          <el-input type="textarea" clearable v-model="recipientForm.address" maxlength="2000" :rows="6" placeholder="Please input" />
        </el-form-item>
        <el-button style="margin: 0 0 20px 120px;" type="primary" size="small" @click="clearInfo('address')">Clear All</el-button>
        <el-form-item prop="cc" label="CC Recipient:" :rules="[{ required: true, message: 'Please input'}]">
          <el-input type="textarea" clearable v-model="recipientForm.cc" maxlength="2000" :rows="6" placeholder="Please input" />
        </el-form-item>
        <el-button style="margin: 0 0 20px 120px;" type="primary" size="small" @click="clearInfo('cc')">Clear All</el-button>
      </el-form>
      <div style="text-align: right">
        <el-button size="small" @click="closeRecipientDialog()" :loading="sendLoading">Cancel</el-button>
        <el-button type="primary" size="small" @click="sendWeekly()" :loading="sendLoading">Confirm</el-button>
      </div>
		</el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import historyDialog from './history.vue'
  export default {
    name: 'weeklyReportCus',
		components: {
      historyDialog,
		},
		props: {
			id: {
        type: Number,
        default: null,
      },
      allData: {
				type: Object,
        default: {},
			},
		},
		watch: {
		},
    created () {
      this.getSelectInfo();
      // this.getWeeklyInfo();
    },
    data () {
      return {
        moment,
        activeNames: ['1', '2', '3', '4', '5', '6'],
        weeklyReportCusForm: {
          weeklyStartEndDate: [],
          helpList: [{}],
          riskList: [{}],
          thisWeekWorkProgressList: [{}],
          nextWeekWorkProgressList: [{}],
          milestoneList: [{}],
          projectOverview: '',
          overallProjectProgress: '',
        },
				initUser: [],
        riskLevel: ['High', 'Medium', 'Low'],
        projectRiskType: [],
        milestoneStatus: ['Not Started', 'In Progress', 'Completed'],
        confirmLoading: false,
        sendLoading: false,
        recipientModal: false,
        addressData: '',
        ccData: '',
        recipientForm: {
          address: '',
          cc: '',
        },
      }
    },
    methods: {
			getWeeklyInfo() {
        let url =`${this.$store.state.islhurl}weeklyReportCustomer/getByMajorProjectId`;
        let params = {
          majorProjectId: this.id,
          islhToken: sessionStorage.getItem('islhtoken'),
        }
        this._post(url, params).then(
          res => {  
            if(res && res.data) {
              const data = res.data;
              let nextWeekWorkProgressListNew = [];
              let thisWeekWorkProgressListNew = [];
              data.nextWeekWorkProgressList && data.nextWeekWorkProgressList.forEach(item => {
                nextWeekWorkProgressListNew.push({
                  jobContent: item,
                })
              })
              data.thisWeekWorkProgressList && data.thisWeekWorkProgressList.forEach(item => {
                thisWeekWorkProgressListNew.push({
                  jobContent: item,
                })
              })
              this.weeklyReportCusForm = {
                ...res.data,
                nextWeekWorkProgressList: nextWeekWorkProgressListNew.length === 0 ? [{}] : nextWeekWorkProgressListNew,
                thisWeekWorkProgressList: thisWeekWorkProgressListNew.length === 0 ? [{}] : thisWeekWorkProgressListNew,
                helpList: data.helpList && data.helpList.length > 0 ? data.helpList : [{}],
                riskList: data.riskList && data.riskList.length > 0 ? data.riskList : [{}],
                milestoneList: data.milestoneList && data.milestoneList.length > 0 ? data.milestoneList : [{}],
                weeklyStartEndDate: data.reportStartDate ? [data.reportStartDate, data.reportEndDate] : [],
              }
              this.recipientForm = {
                address: res.data.addresseeList ? res.data.addresseeList.join(';') : '',
                cc: res.data.ccList ? res.data.ccList.join(';') : '',
              }
              this.addressData = res.data.addresseeList;
              this.ccData = res.data.ccList;
              // if(data.riskList && data.riskList.length > 0) {
							//   const allLeaders = data.riskList.flatMap(entry => entry.owner);
							//   this.initUser = [...new Set(allLeaders)];
              // }
              this.$nextTick(() => {
                this.$refs.weeklyReportCusForm.clearValidate();
              });
            }
          }
        )
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'projectRiskType',
					// 'customerIndustry',
          // 'riskLevel',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
      addRow(index, name) {
				this.weeklyReportCusForm[name].splice(index + 1, 0, {});
      },
			deleteRow(index, name) {
				this.weeklyReportCusForm[name].splice(index, 1);
			},
      filterObjects(arr, dateFieldNames) {
        var result = []; // 用于存储过滤后的对象
        for (var i = 0; i < arr.length; i++) {
          var obj = arr[i];
          var newObj = {}; // 用于存储转换后的对象
          var hasNonEmptyValue = false; // 检查对象是否有非空值
          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              var value = obj[key];
              if (dateFieldNames.indexOf(key) !== -1 && value) {
                // 如果属性是日期字段且值为有效的日期字符串，则进行格式转换
                newObj[key] = moment(value).format('YYYY-MM-DD');
              } else {
                newObj[key] = value;
              }
              // 检查当前属性是否为非空值
              if (value !== null && 
                  value !== undefined && 
                  !(typeof value === 'string' && value.trim() === '') &&
                  !(Array.isArray(value) && value.length === 0) &&
                  !(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)) {
                hasNonEmptyValue = true;
              }
            }
          }
          // 如果对象有至少一个非空值，添加到结果数组
          if (hasNonEmptyValue) {
            result.push(newObj);
          }
        }

        return result;
      },
      confirmWeekly(loading) {
        this.$refs.weeklyReportCusForm.validate((valid) => {
					if (valid) {
            const { weeklyStartEndDate, thisWeekWorkProgressList, nextWeekWorkProgressList, helpList, riskList, milestoneList } = this.weeklyReportCusForm;
            let thisWeekWorkProgressListNew = [];
            thisWeekWorkProgressList.forEach(item=> {
              thisWeekWorkProgressListNew.push(item.jobContent)
            })
            let nextWeekWorkProgressListNew = [];
            nextWeekWorkProgressList.forEach(item=> {
              nextWeekWorkProgressListNew.push(item.jobContent)
            })
            let addresseeList = [];
            let ccList = [];
            if(this.recipientForm.address) {
              const splitData = this.recipientForm.address.split(';');
              addresseeList = splitData.filter(item => item.trim() !== '');
            }
            if(this.recipientForm.cc) {
              const splitCCData = this.recipientForm.cc.split(';');
              ccList = splitCCData.filter(item => item.trim() !== '');
            }
            const helpListNew = this.filterObjects(helpList, ['theTimeOfResolution']);
            const riskListNew = this.filterObjects(riskList, ['plannedClosingDate']);
            const milestoneListNew = this.filterObjects(milestoneList, ['startDate', 'endDate']);
            let params = {
              ...this.weeklyReportCusForm,
              majorProjectId: this.id,
					    islhToken: sessionStorage.getItem('islhtoken'),
					    eosToken: sessionStorage.getItem('eostoken'),
              reportStartDate: moment(weeklyStartEndDate[0]).format('YYYY-MM-DD'),
              reportEndDate: moment(weeklyStartEndDate[1]).format('YYYY-MM-DD'),
              thisWeekWorkProgressList: thisWeekWorkProgressListNew,
              nextWeekWorkProgressList: nextWeekWorkProgressListNew,
              addresseeList,
              ccList,
              helpList: helpListNew,
              riskList: riskListNew,
              milestoneList: milestoneListNew,
            }
            delete params.weeklyStartEndDate;
						let url =`${this.$store.state.islhurl}weeklyReportCustomer/save`;
            if(loading === 'sendLoading'){
              url =`${this.$store.state.islhurl}weeklyReportCustomer/sendReport`;
            }
						this[loading] = true;
						this._post(url, params).then(
							res => {
                this[loading] = false;
								if(res.code === 200) {
									this.$Message.success('Successful!' );
                  this.getWeeklyInfo();
                  if(loading === 'sendLoading'){
                    this.recipientModal = false;
                  }
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
      },
      openHistoryDialog() {
        this.$refs.historyDialog.historyDialog = true;
        this.$refs.historyDialog.handleSearch();
      },
      openRecipientDialog() {
        this.$refs.weeklyReportCusForm.validate((valid) => {
					if (valid) {
            this.recipientModal = true;
          }
        })
      },
      closeRecipientDialog() {
        this.recipientModal = false;
        this.recipientForm = {
          address: this.addressData ? this.addressData.join(';') : '',
          cc: this.ccData ? this.ccData.join(';') : '',
        }
      },
      clearInfo(type) {
        this.recipientForm[type] = '';
      },
      sendWeekly() {
         this.$refs.recipientForm.validate((valid) => {
					if (valid) {
            this.confirmWeekly('sendLoading');
          }
        })
      }
    },
  }
</script>
<style lang="less" scoped>
#weeklyReportCus {
  .redbg /deep/.el-input__inner {
    background: #FF0000;
  }
  .yellowbg /deep/.el-input__inner {
    background: #FFFF00;
  }
  .greenbg /deep/.el-input__inner {
    background: #92D050;
  }
	.el-form {
		padding: 0 0 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
      width: 0;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
    /deep/.el-date-editor .el-range__icon {
      line-height: 26px;
    }
    .hasStar span {
      color: #F56C6C;
      padding-left: 1px;
    }
    .week-table {
      /deep/td.el-table__cell {
        padding: 20px 0 0 0;
      }
      /deep/.el-form-item {
        margin-bottom: 20px;
      }
    }
	}
  .recipientForm /deep/.el-form-item__label  {
    text-align: left;
  }
  >h2 {
    text-align: center;
    color: #222222;
    font-size: 17px;
    padding-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/major/weeklyReportCus/index.vue